import React, { FC, KeyboardEvent, useEffect, useState } from 'react';
import { CUSTOMER_MODE } from '@montana/constants/customer-mode';
import { useSettings } from '@montana/containers/settings/settings.container';
import { useTranslations } from '@montana/containers/translations';
import { TextInput } from '../form';
import { SvgIcon } from '../svg-icon';
import { useSearchSuggestions } from './search.hook';

type Props = {
    value: string;
    onChange: (value: string) => void;
};

export const SearchInput: FC<Props> = ({value, onChange}) => {
    const translate = useTranslations();
    const [selectedSuggestion, setSelectedSuggestion] = useState<number>(-1)
    const { searchSuggestions } = useSearchSuggestions(value);
    const { customerMode } = useSettings();

    useEffect(() => {
        setSelectedSuggestion(-1)
    }, [value])

    const autoSuggestions = searchSuggestions?.autoCompletes || [];

    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
        switch (event.key) {
            case "ArrowDown":
                event.preventDefault();
                if (selectedSuggestion < autoSuggestions.length - 1) {
                    setSelectedSuggestion(selectedSuggestion + 1);
                } else {
                    setSelectedSuggestion(0);
                }
                break;
            case "ArrowUp":
                event.preventDefault();
                if (selectedSuggestion > -1) {
                    setSelectedSuggestion(selectedSuggestion - 1);
                } else {
                    setSelectedSuggestion(autoSuggestions.length - 1);
                }
                break;
            case "Enter":
                event.preventDefault();
                if (selectedSuggestion > -1) {
                    onChange(autoSuggestions[selectedSuggestion]);
                }
                break;
            default:
                break;
        }
    }

    return (
        <div className="search__input">
            <div className="search__input-wrapper">
                <TextInput className="text-input--basic search__input"
                    value={value}
                    autoFocus
                    autoFocusDelay={400}
                    optionalIndicator={false}
                    inlineLabel={false}
                    onChange={e => onChange(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder={translate(t => customerMode === CUSTOMER_MODE.PROFESSIONAL ? t.filterAndSearch.productSearchPlaceholderProfessional : t.filterAndSearch.productSearchPlaceholder, '[Search products, color & inspiration]')}
                >
                    {value && (
                        <>
                            {/* We don't do anything here, but the customer wanted a "search button" */}
                            <button key="search__new" className="search__new" onClick={() => onChange(value)}>
                                <SvgIcon iconName="search" />
                            </button>
                            <button key="search__new-reset" className="search__new" onClick={() => onChange('')}>
                                <SvgIcon iconName="close" />
                            </button>
                        </>
                    )
                    }
                </TextInput>
            </div>
            {!!autoSuggestions.length && (
                <div className="autosuggestions">
                    {autoSuggestions?.map((s, i) => (
                        <button
                            key={i}
                            className={`autosuggestions__suggestion${i === selectedSuggestion ? ' autosuggestions__suggestion--active' : ''}`}
                            onClick={() => onChange(s)}
                        >
                            {s}
                        </button>
                    ))}
                </div>
            )}
        </div>
    )

}
